import {publicAxios} from 'config/RequestInterceptor';
import {useQuery} from "react-query";


const getEvents = async () => {
    return await publicAxios.get('/api/events?populate=*').then(data => (data.data.data))
}

const time = {
    staleTime: 60 * 1000 * 15,
    cacheTime: 60 * 1000 * 30
};

export const useGetEvents = () => {
    return useQuery(
        'get-all-events',
        getEvents,
        time
    );
}